var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "col-lg-12" }, [
    _c("div", { staticClass: "modal-body" }, [
      _c("div", { staticClass: "m-portlet__body" }, [
        _c("div", { staticClass: "form-group m-form__group row" }, [
          _c(
            "div",
            {
              class: [
                {
                  "has-danger": _vm.errors.has("vehicle_type_id" + _vm.idx_car)
                },
                "col-lg-6"
              ]
            },
            [
              _c("label", { attrs: { for: "vehicle_type_id" + _vm.idx_car } }, [
                _vm._v(
                  _vm._s(
                    _vm._f("capitalize")(_vm._f("translate")("vehicle_type"))
                  )
                )
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value:
                        _vm.authorization[_vm.idx_car].cargo_cars
                          .vehicle_type_id,
                      expression:
                        "authorization[idx_car].cargo_cars.vehicle_type_id"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  class: {
                    "form-control": true,
                    error: _vm.errors.has("vehicle_type_id" + _vm.idx_car)
                  },
                  attrs: {
                    "data-vv-as": _vm._f("translate")("vehicle_type"),
                    name: "vehicle_type_id" + _vm.idx_car,
                    id: "vehicle_type_id" + _vm.idx_car
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.authorization[_vm.idx_car].cargo_cars,
                          "vehicle_type_id",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                      function($event) {
                        return _vm.cargo_vehicles(
                          _vm.authorization[_vm.idx_car].cargo_cars
                            .vehicle_type_id,
                          _vm.idx_car
                        )
                      }
                    ]
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [
                    _vm._v(_vm._s(_vm._f("capitalize")("select_an_option")))
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.cargo_vehicle_type, function(cargo_vehicle, idx) {
                    return _c(
                      "option",
                      { key: idx, domProps: { value: cargo_vehicle.id } },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm._f("capitalize")(cargo_vehicle.name)) +
                            "\n            "
                        )
                      ]
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("vehicle_type_id" + _vm.idx_car),
                      expression: "errors.has(`vehicle_type_id${idx_car}`)"
                    }
                  ],
                  staticClass: "m-form__help m--font-danger"
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.translateErrorMessage(
                          "vehicle_type",
                          _vm.errors.first("vehicle_type_id" + _vm.idx_car)
                        )
                      ) +
                      " "
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm.authorization[_vm.idx_car].cargo_cars.vehicle_type_id !== ""
            ? _c(
                "div",
                {
                  class: [
                    {
                      "has-danger": _vm.errors.has(
                        "cargo_type_vehicle_type" + _vm.idx_car
                      )
                    },
                    "col-md-6 container-vehicle"
                  ]
                },
                [
                  _c(
                    "label",
                    { attrs: { for: "cargo_type_vehicle_type" + _vm.idx_car } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm._f("translate")("vehicle_type")
                          )
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.authorization[_vm.idx_car].cargo_cars
                              .cargo_vehicle_type,
                          expression:
                            "authorization[idx_car].cargo_cars.cargo_vehicle_type"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      class: {
                        "form-control": true,
                        error: _vm.errors.has(
                          "cargo_type_vehicle_type" + _vm.idx_car
                        )
                      },
                      attrs: {
                        "data-vv-as": _vm._f("translate")("vehicle_type"),
                        name: "cargo_type_vehicle_type" + _vm.idx_car,
                        id: "cargo_type_vehicle_type" + _vm.idx_car
                      },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.authorization[_vm.idx_car].cargo_cars,
                            "cargo_vehicle_type",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "" } }, [
                        _vm._v(_vm._s(_vm._f("capitalize")("select_an_option")))
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.cargo_type_vehicles, function(
                        cargo_vehicle,
                        idx
                      ) {
                        return _vm.hideCargoType(
                          _vm.authorization[_vm.idx_car].cargo_cars
                            .vehicle_type_id,
                          cargo_vehicle.type
                        )
                          ? _c(
                              "option",
                              {
                                key: idx,
                                domProps: { value: cargo_vehicle.name }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm._f("capitalize")(cargo_vehicle.name)
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has(
                            "cargo_type_vehicle_type" + _vm.idx_car
                          ),
                          expression:
                            "errors.has(`cargo_type_vehicle_type${idx_car}`)"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.translateErrorMessage(
                              "vehicle_type",
                              _vm.errors.first(
                                "cargo_type_vehicle_type" + _vm.idx_car
                              )
                            )
                          ) +
                          " "
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.authorization[_vm.idx_car].cargo_cars.vehicle_type_id !== ""
            ? _c(
                "div",
                {
                  class: [
                    {
                      "has-danger": _vm.errors.has(
                        "truck_license_plate" + _vm.idx_car
                      )
                    },
                    "col-lg-6 container-vehicle"
                  ]
                },
                [
                  _c(
                    "label",
                    { attrs: { for: "truck_license_plate" + _vm.idx_car } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm._f("translate")("truck_license_plate")
                          )
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value:
                          _vm.authorization[_vm.idx_car].cargo_cars
                            .truck_license_plate,
                        expression:
                          "authorization[idx_car].cargo_cars.truck_license_plate"
                      }
                    ],
                    staticClass: "form-control m-input",
                    attrs: {
                      "data-vv-as": _vm._f("translate")("truck_license_plate"),
                      name: "truck_license_plate" + _vm.idx_car,
                      id: "truck_license_plate" + _vm.idx_car
                    },
                    domProps: {
                      value:
                        _vm.authorization[_vm.idx_car].cargo_cars
                          .truck_license_plate
                    },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.authorization[_vm.idx_car].cargo_cars,
                          "truck_license_plate",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has(
                            "truck_license_plate" + _vm.idx_car
                          ),
                          expression:
                            "errors.has(`truck_license_plate${idx_car}`)"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.translateErrorMessage(
                              "truck_license_plate",
                              _vm.errors.first(
                                "truck_license_plate" + _vm.idx_car
                              )
                            )
                          ) +
                          " "
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.authorization[_vm.idx_car].cargo_cars.vehicle_type_id !== ""
            ? _c(
                "div",
                {
                  class: [
                    {
                      "has-danger": _vm.errors.has("cargo_order" + _vm.idx_car)
                    },
                    "col-lg-6 container-vehicle"
                  ]
                },
                [
                  _c("label", { attrs: { for: "cargo_order" + _vm.idx_car } }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("capitalize")(_vm._f("translate")("cargo_order"))
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value:
                          _vm.authorization[_vm.idx_car].cargo_cars.cargo_order,
                        expression:
                          "authorization[idx_car].cargo_cars.cargo_order"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "form-control m-input",
                    attrs: {
                      "data-vv-as": _vm._f("translate")("cargo_order"),
                      name: "cargo_order" + _vm.idx_car,
                      id: "cargo_order" + _vm.idx_car
                    },
                    domProps: {
                      value:
                        _vm.authorization[_vm.idx_car].cargo_cars.cargo_order
                    },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.authorization[_vm.idx_car].cargo_cars,
                          "cargo_order",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("cargo_order" + _vm.idx_car),
                          expression: "errors.has(`cargo_order${idx_car}`)"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.translateErrorMessage(
                              "cargo_order",
                              _vm.errors.first("cargo_order" + _vm.idx_car)
                            )
                          ) +
                          " "
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.is_articulate
            ? _c(
                "div",
                {
                  class: [
                    {
                      "has-danger": _vm.errors.has(
                        "trailer_license_plate" + _vm.idx_car
                      )
                    },
                    "col-lg-6 container-vehicle"
                  ]
                },
                [
                  _c(
                    "label",
                    { attrs: { for: "trailer_license_plate" + _vm.idx_car } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm._f("translate")("trailer_license_plate")
                          )
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value:
                          _vm.authorization[_vm.idx_car].cargo_cars
                            .trailer_license_plate,
                        expression:
                          "authorization[idx_car].cargo_cars.trailer_license_plate"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "form-control m-input",
                    attrs: {
                      "data-vv-as": _vm._f("translate")(
                        "trailer_license_plate"
                      ),
                      name: "trailer_license_plate" + _vm.idx_car,
                      id: "trailer_license_plate" + _vm.idx_car
                    },
                    domProps: {
                      value:
                        _vm.authorization[_vm.idx_car].cargo_cars
                          .trailer_license_plate
                    },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.authorization[_vm.idx_car].cargo_cars,
                          "trailer_license_plate",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has(
                            "trailer_license_plate" + _vm.idx_car
                          ),
                          expression:
                            "errors.has(`trailer_license_plate${idx_car}`)"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.translateErrorMessage(
                              "trailer_license_plate",
                              _vm.errors.first(
                                "trailer_license_plate" + _vm.idx_car
                              )
                            )
                          ) +
                          " "
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.authorization[_vm.idx_car].cargo_cars.vehicle_type_id !== ""
            ? _c(
                "div",
                {
                  class: [
                    {
                      "has-danger": _vm.errors.has(
                        "container_number" + _vm.idx_car
                      )
                    },
                    "col-lg-6 container-vehicle"
                  ]
                },
                [
                  _c(
                    "label",
                    { attrs: { for: "container_number" + _vm.idx_car } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm._f("translate")("container_number")
                          )
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value:
                          _vm.authorization[_vm.idx_car].cargo_cars
                            .container_number,
                        expression:
                          "authorization[idx_car].cargo_cars.container_number"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "numeric",
                        expression: "'numeric'"
                      }
                    ],
                    staticClass: "form-control m-input",
                    attrs: {
                      "data-vv-as": _vm._f("translate")("container_number"),
                      name: "container_number" + _vm.idx_car,
                      id: "container_number"
                    },
                    domProps: {
                      value:
                        _vm.authorization[_vm.idx_car].cargo_cars
                          .container_number
                    },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.authorization[_vm.idx_car].cargo_cars,
                          "container_number",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has(
                            "container_number" + _vm.idx_car
                          ),
                          expression: "errors.has(`container_number${idx_car}`)"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.translateErrorMessage(
                              "container_number",
                              _vm.errors.first("container_number" + _vm.idx_car)
                            )
                          ) +
                          " "
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.authorization[_vm.idx_car].cargo_cars.vehicle_type_id !== ""
            ? _c(
                "div",
                {
                  class: [
                    {
                      "has-danger": _vm.errors.has(
                        "cargo_vehicle_brand" + _vm.idx_car
                      )
                    },
                    "col-lg-6 container-vehicle"
                  ]
                },
                [
                  _c(
                    "label",
                    { attrs: { for: "cargo_vehicle_brand" + _vm.idx_car } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm._f("translate")("cargo_vehicle_brand")
                          )
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value:
                          _vm.authorization[_vm.idx_car].cargo_cars
                            .cargo_vehicle_brand,
                        expression:
                          "authorization[idx_car].cargo_cars.cargo_vehicle_brand"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "alpha|min:5|max:20",
                        expression: "'alpha|min:5|max:20'"
                      }
                    ],
                    staticClass: "form-control m-input",
                    attrs: {
                      "data-vv-as": _vm._f("translate")("cargo_vehicle_brand"),
                      name: "cargo_vehicle_brand" + _vm.idx_car,
                      id: "cargo_vehicle_brand" + _vm.idx_car
                    },
                    domProps: {
                      value:
                        _vm.authorization[_vm.idx_car].cargo_cars
                          .cargo_vehicle_brand
                    },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.authorization[_vm.idx_car].cargo_cars,
                          "cargo_vehicle_brand",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has(
                            "cargo_vehicle_brand" + _vm.idx_car
                          ),
                          expression:
                            "errors.has(`cargo_vehicle_brand${idx_car}`)"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.translateErrorMessage(
                              "cargo_vehicle_brand",
                              _vm.errors.first(
                                "cargo_vehicle_brand" + _vm.idx_car
                              )
                            )
                          ) +
                          " "
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.authorization[_vm.idx_car].cargo_cars.vehicle_type_id !== ""
            ? _c(
                "div",
                {
                  class: [
                    {
                      "has-danger": _vm.errors.has(
                        "cargo_vehicle_color" + _vm.idx_car
                      )
                    },
                    "col-lg-6 container-vehicle"
                  ]
                },
                [
                  _c(
                    "label",
                    { attrs: { for: "cargo_vehicle_color" + _vm.idx_car } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm._f("translate")("cargo_vehicle_color")
                          )
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value:
                          _vm.authorization[_vm.idx_car].cargo_cars
                            .cargo_vehicle_color,
                        expression:
                          "authorization[idx_car].cargo_cars.cargo_vehicle_color"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "alpha|min:4|max:20",
                        expression: "'alpha|min:4|max:20'"
                      }
                    ],
                    staticClass: "form-control m-input",
                    attrs: {
                      "data-vv-as": _vm._f("translate")("cargo_vehicle_color"),
                      name: "cargo_vehicle_color" + _vm.idx_car,
                      id: "cargo_vehicle_color" + _vm.idx_car
                    },
                    domProps: {
                      value:
                        _vm.authorization[_vm.idx_car].cargo_cars
                          .cargo_vehicle_color
                    },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.authorization[_vm.idx_car].cargo_cars,
                          "cargo_vehicle_color",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has(
                            "cargo_vehicle_color" + _vm.idx_car
                          ),
                          expression:
                            "errors.has(`cargo_vehicle_color${idx_car}`)"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.translateErrorMessage(
                              "cargo_vehicle_color",
                              _vm.errors.first(
                                "cargo_vehicle_color" + _vm.idx_car
                              )
                            )
                          ) +
                          " "
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.authorization[_vm.idx_car].cargo_cars.vehicle_type_id !== ""
            ? _c(
                "div",
                {
                  class: [
                    {
                      "has-danger": _vm.errors.has(
                        "cargo_vehicle_model" + _vm.idx_car
                      )
                    },
                    "col-lg-6 container-vehicle"
                  ]
                },
                [
                  _c(
                    "label",
                    { attrs: { for: "cargo_vehicle_model" + _vm.idx_car } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm._f("translate")("cargo_vehicle_model")
                          )
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value:
                          _vm.authorization[_vm.idx_car].cargo_cars
                            .cargo_vehicle_model,
                        expression:
                          "authorization[idx_car].cargo_cars.cargo_vehicle_model"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "min:4|max:20",
                        expression: "'min:4|max:20'"
                      }
                    ],
                    staticClass: "form-control m-input",
                    attrs: {
                      "data-vv-as": _vm._f("translate")("cargo_vehicle_model"),
                      name: "cargo_vehicle_model" + _vm.idx_car,
                      id: "cargo_vehicle_model" + _vm.idx_car
                    },
                    domProps: {
                      value:
                        _vm.authorization[_vm.idx_car].cargo_cars
                          .cargo_vehicle_model
                    },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.authorization[_vm.idx_car].cargo_cars,
                          "cargo_vehicle_model",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has(
                            "cargo_vehicle_model" + _vm.idx_car
                          ),
                          expression:
                            "errors.has(`cargo_vehicle_model${idx_car}`)"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.translateErrorMessage(
                              "cargo_vehicle_model",
                              _vm.errors.first(
                                "cargo_vehicle_model" + _vm.idx_car
                              )
                            )
                          ) +
                          " "
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.authorization[_vm.idx_car].cargo_cars.vehicle_type_id !== ""
            ? _c(
                "div",
                {
                  class: [
                    {
                      "has-danger": _vm.errors.has(
                        "carrier_company" + _vm.idx_car
                      )
                    },
                    "col-lg-6 container-vehicle"
                  ]
                },
                [
                  _c(
                    "label",
                    { attrs: { for: "carrier_company" + _vm.idx_car } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm._f("translate")("carrier_company")
                          )
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value:
                          _vm.authorization[_vm.idx_car].cargo_cars
                            .carrier_company,
                        expression:
                          "authorization[idx_car].cargo_cars.carrier_company"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "min:5|max:20",
                        expression: "'min:5|max:20'"
                      }
                    ],
                    staticClass: "form-control m-input",
                    attrs: {
                      "data-vv-as": _vm._f("translate")("carrier_company"),
                      name: "carrier_company" + _vm.idx_car,
                      id: "carrier_company" + _vm.idx_car
                    },
                    domProps: {
                      value:
                        _vm.authorization[_vm.idx_car].cargo_cars
                          .carrier_company
                    },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.authorization[_vm.idx_car].cargo_cars,
                          "carrier_company",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has(
                            "carrier_company" + _vm.idx_car
                          ),
                          expression: "errors.has(`carrier_company${idx_car}`)"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.translateErrorMessage(
                              "carrier_company",
                              _vm.errors.first("carrier_company" + _vm.idx_car)
                            )
                          ) +
                          " "
                      )
                    ]
                  )
                ]
              )
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b0677a28", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0677a28","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/cargo_authorization/AddVehicle.vue
// module id = 439
// module chunks = 0 1 7 31